import { TextAlign, TextAnchor } from '@/types';

// @ts-ignore start is equal to the default value
const mapping: Record<TextAnchor, TextAlign> = {
  middle: 'center',
  end: 'right',
};

export const textAnchorToAlign = (align: TextAnchor): TextAlign => {
  return mapping[align] || 'left';
};
